import styled from 'styled-components';
import { Grid, media } from '@simplywallst/ui-core';
import { RouterLink } from '@redux-first-router-link';

export const Wrapper = styled(Grid)`
  margin: ${({ theme }) => `${theme.x3spacePx}px 0`};
  ${media.mdDown`
    margin-left: ${({ theme }) => theme.x2spacePx}px;
    margin-right: ${({ theme }) => theme.x2spacePx}px;
  `}
`;

export const Link = styled(RouterLink)`
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  ${({ theme }) => theme.typography.baseStrong}
  color: ${({ theme }) => theme.color.white};
  background: ${({ theme }) => theme.color.noir};
  border: 1px solid ${({ theme }) => theme.color.whiteRGBA(0.1)};
  border-radius: ${({ theme }) => theme.x1spacePx}px;
  padding: ${({ theme }) => `${theme.x5spacePx}px ${theme.x8spacePx}px`};
  > svg {
    width: ${({ theme }) => theme.x5spacePx}px;
    height: ${({ theme }) => theme.x5spacePx}px;
    margin-bottom: ${({ theme }) => theme.x1spacePx}px;
    > * {
      fill: ${({ theme }) => theme.color.brand01};
    }
  }
  &:hover {
    background: ${({ theme }) => theme.color.charcoal};
  }
`;
